import React from "react";
import { Link, useLocation } from "react-router-dom";
import { AdminNavigationItem } from "../../routes/adminNavigationConfig";
import { useAppContext } from "../../../contexts/AppContext";
interface SideBarProps {
    navigation: AdminNavigationItem[];
}

const SideBar: React.FC<SideBarProps> = ({ navigation }) => {
    const { user } = useAppContext();
    const location = useLocation();

    const userType =
        user?.role === Number(process.env.REACT_APP_SUPER_ADMIN)
            ? 'SUPER_ADMIN'
            : user?.role === Number(process.env.REACT_APP_ADMIN)
                ? 'ADMIN'
                : user?.role === Number(process.env.REACT_APP_USER)
                    ? 'USER'
                    : 'GUEST';

    // hide admin-profile from sidebar
    const filteredNavigationConfig = navigation.filter((item: AdminNavigationItem) =>
        item.role?.includes(userType) && item.path !== '/admin-profile'
    );

    const signOut = () => {
        localStorage.clear();
        window.location.href = '/';
    }

    return (
        <nav className="bg-primaryColor h-screen min-w-[90px] md:min-w-[263px]">
            <div className="bg-secondaryColor rounded-b-[30px] md:rounded-b-[40px]">
                <Link className="flex items-center justify-center" to="/">
                    <img
                        className="w-[70px] md:w-[165px] pb-7 pt-12"
                        src="assets/images/logo/logo-black.png"
                        alt="Workflow"
                    />
                </Link>

            </div>
            <div className=" p-5 md:p-8 flex flex-col justify-between">
                <div className="flex flex-col items-center gap-2 overflow-y-auto h-[calc(100vh-220px)]">
                    {filteredNavigationConfig
                        .filter((item) => item.isSlider)
                        .map((item) => (
                            <Link
                                key={item.title}
                                to={String(item.path)}
                                className={`flex items-center justify-center px-2 md:justify-start rounded-lg w-full py-2 text-white ${location.pathname === item.path
                                    ? "bg-[#434E5B]"
                                    : ""
                                    }`}
                            >
                                <div className=" md:w-14">
                                    <i className={`${item.icon} text-2xl`} />
                                </div>
                                <span className="hidden md:block">{item.title}</span>
                            </Link>
                        ))}
                </div>
                <div className="flex flex-col gap-3">
                    <div className="h-[0.1rem] bg-white w-full" />
                    <div className="flex items-center justify-between gap-2 flex-col md:flex-row">
                        <Link
                            to="/admin-profile"
                            className="flex items-center justify-between gap-3"
                        >
                            <div className="flex-shrink-0 w-[40px] h-[40px] rounded-full overflow-hidden">
                                <img
                                    className="w-full h-full rounded-full object-cover"
                                    src="https://images.ctfassets.net/h6goo9gw1hh6/2sNZtFAWOdP1lmQ33VwRN3/24e953b920a9cd0ff2e1d587742a2472/1-intro-photo-final.jpg?w=1200&h=992&fl=progressive&q=70&fm=jpg"
                                    alt="Workflow"
                                />
                            </div>
                            <h3 className="text-white text-[15px] group-hover:text-secondaryColor hidden md:block">
                                {
                                    process.env.REACT_APP_SUPER_ADMIN === String(user?.role) ? 'Super Admin' : 'Admin'
                                }
                            </h3>
                        </Link>
                        <button
                            className="p-1 text-white rounded-lg"
                            onClick={signOut}
                        >
                            <i className="fas fa-sign-out-alt text-2xl" />
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default SideBar;